import { RelatorioAssociadosInativosModel } from '@/models/administracao/associados-inativos/RelatorioAssociadosInativosModel';
import { integracaoContabilApi } from '@/api/IntegracaoContabilApi';

export default class GerencialAssociadosInativosService {

    static gerarRelatorio(tipo: string, request: RelatorioAssociadosInativosModel) {
        return integracaoContabilApi.gerarRelatorioAssociadosInativos(tipo, request);
    }

    static buscarAssociadosInativos(request: RelatorioAssociadosInativosModel) {
        return integracaoContabilApi.buscarAssociadosInativos(request);
    }
}